<div class="container" style='height: 100% !important;'>
    <div class="col-12" style='height: 100% !important;'>
        <div class="row" style='height: 100% !important;'>
            <div class='col-12 item-details '>
                <!-- <div class='head col-12'>
                Message Content*
            </div> -->
                <div>
                    <div class='value col-10'  [innerHTML]="messageContent">
                    </div>
                    <div class='col-10 d-flex justify-content-start' *ngIf='messageContent?.attachments?.length > 0 '>
                        <app-mini-image *ngFor='let imgPath of messageContent.attachments' [imgPath]='imgPath.path'>
                        </app-mini-image>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>